import moment from "moment";
import type { MonthlyReport } from "../northstar/MonthlyReport";
import { Policy } from "../northstar/Policy/Policy";
import type { EquipmentDriverChangeDto } from "./Equipment";

/** A submitted report also needs AM review; finalization is not required. */
export function hasCompletedAdvancedDriverReport(
    policy: Policy.IHasAttributes,
    reports: Pick<MonthlyReport, "year" | "month" | "submittedDate" | "finalizedDate">[],
    atDate: moment.MomentInput
): boolean {
    if (!Policy.isCompositeAdvanced(policy)) return false;
    const date = moment.utc(atDate);
    return reports.some(
        (report) => report.year === date.year() && report.month === date.month() + 1 && !!(report.submittedDate || report.finalizedDate)
    );
}

export function getDriverCoverageAdditions(
    coverages: EquipmentDriverChangeDto["coverages"],
    originalCoverages: EquipmentDriverChangeDto["coverages"] = []
): EquipmentDriverChangeDto["coverages"] {
    return coverages.filter(
        (coverage) =>
            !coverage.remove &&
            !originalCoverages.some(
                (original) =>
                    !original.remove && original.policyId === coverage.policyId && original.coverageOptionId === coverage.coverageOptionId
            )
    );
}
